import { IsBoolean, IsDate, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';

export class SocialLinksDto extends BaseDto {

  @IsString()
  name: string;

  @IsNumber()
  merchantId: number;

  @IsString()
  link: string;

  @IsBoolean()
  @IsOptional()
  isActive: boolean;

  @IsDate()
  @IsOptional()
  createdDate?: Date;
  
  @IsDate()
  @IsOptional()
  modifiedDate?: Date;

  @IsNumber()
  @IsOptional()
  lastModifiedUserId?: number;

  @IsNumber()
  @IsOptional()
  version?: number;

  merchant?: MerchantDto;

}
